module.exports = __webpack_public_path__ + "img/metas.431e4532.svg";